import { LitElement, html, css } from 'lit';
import { Image } from '../Image/Image';
import { generateProfileImageByInitials } from '../../../lib/helpers';
import { Message_bold, Message_outline, Broadcast_bold, Broadcast_outline } from '../../../constants/chat-assets';

export class ProfileSidebar extends LitElement {
  static properties = {
    userMetaData: { type: Object },
    openProfile: { type: Function },
    openChat: { type: Function },
    openGroupCast: { type: Function },
    toggleTheme: { type: Function },
    activeTab: { type: String },
    defaultTheme: { type: String },
    isMqttConnected: { type: Boolean },
    unreadConversationsCount: { type: Number },
  };

  constructor() {
    super();
    this.userMetaData = {};
    this.activeTab = 'Chat';
  }

  static styles = css`
    .profile-tab {
      min-width: 50px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      height: 100%;
      background-color:var(--bg-primary-color)
    }
    .chat-button {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
    }
    .active-Chat {
      background-color: var(--bg-primary-light);
      border-radius: 50%;
      margin-top: 10px;
    }
    .mqtt-indicator {
      position: absolute;
      right: 5px;
      bottom: 7px;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      filter: blur(0.3px);
    }

    .mqtt-indicator.connected {
      background-color: var(--text-success-color);
    }

    .mqtt-indicator.disconnected {
      background-color: var(--text-danger-color);
    }
      .top-buttons{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction:column;
      gap:10px;
      padding:10px 0px;
      }
    .unread-count {
      position: absolute;
      right: 0px;
      top: 0px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: var(--text-unreadcount-color);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 700;
      color: var(--text-incoming-message);
    }
    @media (max-width: 768px) {
      .profile-tab {
        display: none;
      }
    }
  `;

  render() {
    return html`
      <div class="profile-tab">
       <div class='top-buttons' >
        <div class=" ${this.activeTab === 'Chat' ? 'active-Chat' : ''} chat-button" title="Chat" @click="${this.openChat}">
           ${Image({
            src: this.activeTab === 'Chat' ? Message_bold : Message_outline,
            alt: 'profile image',
            width: '30px',
            height: '30px',
            objectFit: 'cover',
            cursor:'pointer',
          })}
          ${this.unreadConversationsCount > 0 ? html`<div class="unread-count">${this.unreadConversationsCount}</div>` : ''}
        </div>
        <div class="${this.activeTab === 'GroupCast' ? 'active-Chat' : ''} chat-button" title="GroupCast" @click="${this.openGroupCast}">
          ${Image({
            src: this.activeTab === 'GroupCast' ? Broadcast_bold : Broadcast_outline,
            alt: 'broadcast image',
            objectFit: 'cover',
            cursor:'pointer',
          })}
          </div>
       </div>
        <div class="${this.activeTab === 'Profile' ? 'active-Chat' : ''} chat-button" title="Profile" @click="${this.openProfile}">
          ${Image({
            src: this.userMetaData.userProfileImageUrl,
            alt: 'profile image',
            width: '30px',
            height: '30px',
            objectFit: 'cover',
            borderRadius: '50%',
            placeholderImage: generateProfileImageByInitials(this.userMetaData?.userName, 90, 90),
          })}
          ${this.isMqttConnected ? html`<div class="mqtt-indicator connected"></div>` : html`<div class="mqtt-indicator disconnected"></div>`}
        </div>
      </div>
    `;
  }
}

// Define the custom element
customElements.define('profile-sidebar', ProfileSidebar);
